import React from 'react';
import { string, object } from 'prop-types';

import Icon from 'foundations/Icons/Icon';

import styles from './MapLegend.css';

const MapLegend = ({ legend, icon }) => (
  <div className={styles.wrapper}>
    <Icon icon={icon.name} type={icon.type} />
    <p className={'tag'}>{legend}</p>
  </div>
);

MapLegend.propTypes = {
  legend: string,
  icon: object,
};

MapLegend.defaultProps = {
  legend: 'Point of Presence'
};

export default MapLegend;



// WEBPACK FOOTER //
// ./src/uis/components/Map/MapLegend/MapLegend.js